import { defineStore } from "pinia";
import { fetchClient } from "../../api/v2/client.ts";

export const useClientStore = defineStore("client", {
  state: () => {
    return {
      id: null,
      companyName: null,
      name: null,
      code: null,
      grantType: "password",
      bkkColor100: null,
      bkkColor75: null,
      bkkColor50: null,
      bkkColor25: null,
      bkkColor10: null,
      zppInfoTitle: null,
      zppInfoText: null,
      logoPath: null,
      logoPathDescription: null,
      companyLogoPath: null,
      companyLogoPathDescription: null,
      clientInfoTitle: null,
      companyInfoTitle: null,
      clientWebsite: null,
      companyWebsite: null,
      hasCommunityGroups: null,
      emailTechnicalSupport: null,
      emailSupport: null,
      emailQuestionsApp: null,
      emailQuestionsMembership: null,
      emailQuestionsOffer: null,
      emailQuestionsBKK: null,
      emailQuestionsBGM: null,
      emailQuestionsBGF: null,
      emailMiscellaneous: null,
      urlTechnicalSupport: null,
      urlSupport: null,
      urlQuestionsApp: null,
      urlQuestionsMembership: null,
      urlQuestionsOffer: null,
      urlQuestionsBKK: null,
      urlQuestionsBGM: null,
      urlQuestionsBGF: null,
      urlMiscellaneous: null,
      bkkDataprivacy: null,
      bkkImprint: null,
      bkkSupervisory: null,
      bkkEditorial: null,
      bkkExtendedDataprivacy: null,
      foreignSystemId: null,
      isExternalAuthorizationSystemEnabled: null,
      brandingLogoBkk: null,
      brandingLogoCompany: null,
      externalLinkRegister: null,
      externalLinkTermsOfUse: null,
      externalLinkPrivacy: null,
      externalLinkForgotPassword: null,
      slug: null,
      desktopVersionActivated: null,
      dataprivacy: null,
      legal: null,
      toc: null,
      matomoId: null,
      isMaintenance: null,
      atmCampaign: null,
      passwordResetRedirectTarget: "login",
      customBackgroundImagePath: null,
      companyTabDesignation: null,
      myBkkTabDesignation: null,
    };
  },
  getters: {
    getId(state) {
      return state.id;
    },
    getCompanyName(state) {
      return state.companyName;
    },
    getName(state) {
      return state.name;
    },
    getCode(state) {
      return state.code;
    },
    getGrantType(state) {
      return state.grantType;
    },
    getBkk100(state) {
      return state["bkkColor100"];
    },
    getBkk75(state) {
      return state["bkkColor75"];
    },
    getBkk50(state) {
      return state["bkkColor50"];
    },
    getBkk25(state) {
      return state["bkkColor25"];
    },
    getBkk10(state) {
      return state["bkkColor10"];
    },
    getUserClient(state) {
      return state["rawClient"];
    },
    getLogoPath(state) {
      return state.logoPath;
    },
    getCompanyLogoPath(state) {
      return state.companyLogoPath;
    },
    getLogoPathDescription(state) {
      return state.logoPathDescription;
    },
    getCompanyLogoPathDescription(state) {
      return state.companyLogoPathDescription;
    },
    getClientInfoTitle(state) {
      return state.clientInfoTitle;
    },
    getCompanyInfoTitle(state) {
      return state.companyInfoTitle;
    },
    getClientWebsite(state) {
      return state.clientWebsite;
    },
    getCompanyWebsite(state) {
      return state.companyWebsite;
    },
    getZppInfoTitle(state) {
      return state.zppInfoTitle;
    },
    getZppInfoText(state) {
      return state.zppInfoText;
    },
    getHasCommunityGroups(state) {
      return state.hasCommunityGroups;
    },
    getEmailTechnicalSupport(state) {
      return state.emailTechnicalSupport;
    },
    getEmailSupport(state) {
      return state.emailSupport;
    },
    getEmailQuestionsApp(state) {
      return state.emailQuestionsApp;
    },
    getEmailQuestionsMembership(state) {
      return state.emailQuestionsMembership;
    },
    getEmailQuestionsOffer(state) {
      return state.emailQuestionsOffer;
    },
    getEmailQuestionsBKK(state) {
      return state.emailQuestionsBKK;
    },
    getEmailQuestionsBGM(state) {
      return state.emailQuestionsBGM;
    },
    getEmailQuestionsBGF(state) {
      return state.emailQuestionsBGF;
    },
    getEmailMiscellaneous(state) {
      return state.emailMiscellaneous;
    },
    getUrlTechnicalSupport(state) {
      return state.urlTechnicalSupport;
    },
    getUrlSupport(state) {
      return state.urlSupport;
    },
    getUrlQuestionsApp(state) {
      return state.urlQuestionsApp;
    },
    getUrlQuestionsMembership(state) {
      return state.urlQuestionsMembership;
    },
    getUrlQuestionsOffer(state) {
      return state.urlQuestionsOffer;
    },
    getUrlQuestionsBKK(state) {
      return state.urlQuestionsBKK;
    },
    getUrlQuestionsBGM(state) {
      return state.urlQuestionsBGM;
    },
    getUrlQuestionsBGF(state) {
      return state.urlQuestionsBGF;
    },
    getUrlMiscellaneous(state) {
      return state.urlMiscellaneous;
    },
    getBkkDataprivacy(state) {
      return state.bkkDataprivacy;
    },
    getBkkImprint(state) {
      return state.bkkImprint;
    },
    getBkkSupervisory(state) {
      return state.bkkSupervisory;
    },
    getBkkEditorial(state) {
      return state.bkkEditorial;
    },
    getBkkExtendedDataprivacy(state) {
      return state.bkkExtendedDataprivacy;
    },
    getForeignSystemId(state) {
      return state.foreignSystemId;
    },
    isExternalAuthorizationSystemEnabled(state) {
      return state.isExternalAuthorizationSystemEnabled;
    },
    getExternalLinkRegister(state) {
      return state.externalLinkRegister;
    },
    getExternalLinkTermsOfUse(state) {
      return state.externalLinkTermsOfUse;
    },
    getExternalLinkPrivacy(state) {
      return state.externalLinkPrivacy;
    },
    getExternalLinkForgotPassword(state) {
      return state.externalLinkForgotPassword;
    },
    getSlug(state) {
      return state.slug;
    },
    getDesktopVersionActivated(state) {
      return state.desktopVersionActivated;
    },
    getDataPrivacy(state) {
      return state.dataprivacy;
    },
    getLegal(state) {
      return state.legal;
    },
    getToc(state) {
      return state.toc;
    },
    getMatomoId(state) {
      return state.matomoId;
    },
    getIsMaintenance(state) {
      return state.isMaintenance;
    },
    getAtmCampaign(state) {
      return state.atmCampaign;
    },
    getPasswordResetRedirectTarget(state) {
      return state.passwordResetRedirectTarget;
    },
    getCustomBackgroundImagePath(state) {
      return state.customBackgroundImagePath;
    },
    getCompanyTabDesignation(state) {
      return state.companyTabDesignation;
    },
    getMyBkkTabDesignation(state) {
      return state.myBkkTabDesignation;
    },
    getBrandingLogoBkk(state) {
      return state.brandingLogoBkk;
    },
    getBrandingLogoCompany(state) {
      return state.brandingLogoCompany;
    },
  },
  actions: {
    async getClient(id, slug, force = false) {
      if (!this.id || force) {
        const response = await fetchClient(id, slug);
        if (response && response.data) {
          this.$state = response.data;
        }

        this.setClientColors();
        this.setMatomoSiteId();
      }

      return this.$state;
    },
    setClientColors() {
      const root = document.querySelector(":root");
      root.style.setProperty("--bkk-100", this.$state["bkkColor100"]);
      root.style.setProperty("--bkk-75", this.$state["bkkColor75"]);
      root.style.setProperty("--bkk-50", this.$state["bkkColor50"]);
      root.style.setProperty("--bkk-25", this.$state["bkkColor25"]);
      root.style.setProperty("--bkk-10", this.$state["bkkColor10"]);
    },
    setClientColorsManually(bkk100, bkk75, bkk50, bkk25, bkk10) {
      const root = document.querySelector(":root");
      root.style.setProperty("--bkk-100", bkk100);
      root.style.setProperty("--bkk-75", bkk75);
      root.style.setProperty("--bkk-50", bkk50);
      root.style.setProperty("--bkk-25", bkk25);
      root.style.setProperty("--bkk-10", bkk10);
    },
    setSlug(slug) {
      this.slug = slug;
    },
    setPasswordResetRedirectTarget(target) {
      this.passwordResetRedirectTarget = target;
    },
    setAtmCampaign(campaign) {
      this.atmCampaign = campaign;
    },
    setMatomoSiteId() {
      if (window.hasOwnProperty("_paq")) {
        let siteId =
          this.$state["matomoId"] ??
          import.meta.env.VITE_MATOMO_DEFAULT_SITE_ID;

        window._paq.push([
          function () {
            const currentSiteId = this.getSiteId();

            if (currentSiteId !== siteId) {
              window._paq.push(["setSiteId", siteId]);
            }
          },
        ]);
      }
    },
  },
  persist: {
    key: "slug",
    storage: window.localStorage,
    paths: ["slug", "atmCampaign", "passwordResetRedirectTarget"],
  },
});
